/**
 * CRO collection hero banner.
 * Presentational for now — reserved for sticky/offset hooks later.
 */
export class LpCollectionBanner extends HTMLElement {
  connectedCallback() {
    this.setAttribute('data-lp-ready', '');
  }
}

if (!customElements.get('lp-collection-banner')) {
  customElements.define('lp-collection-banner', LpCollectionBanner);
}
